// Add here the components that you want to bootstrap on PHP pages
import { TrackingComponent } from '@shared/tracking';
// import { NavigationComponent } from '../app/navigation/navigation.component';
import { CompatNavigationComponent } from './compat-navigation.component';

export const components  = [
  {
    selector: 'webapp-compat-tracking',
    loadChildren: 'app/@shared/tracking/tracking.module#TrackingModule',
    component: TrackingComponent,
    path: 'hack_path_not_used'
  },
  {
    selector: 'webapp-compat-navigation',
    loadChildren: 'compat/compat-navigation.module#CompatNavigationModule',
    component: CompatNavigationComponent,
    path: 'hack_path_not_used'
  }
];



// WEBPACK FOOTER //
// ./src/compat/components.ts